<template>
  <div class="lookbook">
    <HeadlessLayout :sections="lookbookContent" />
    <IconButton tag="a" class="close-btn" icon="cross" theme="white" href="/" />
  </div>
</template>

<script>
import HeadlessLayout from "@/layouts/HeadlessLayout.vue";
import IconButton from "@/components/IconButton.vue";

export default {
  name: "Lookbook",
  components: {
    HeadlessLayout,
    IconButton,
  },
  inject: ["mq"],
  props: {
    pageHandle: {
      type: String,
      required: true,
    },
  },
  computed: {
    lookbookContent() {
      return require(`@/content/lookbook/${this.pageHandle}.json`);
    },
  },
  mounted() {
    const lookbookSection = document.querySelector(".lookbook .section");

    const handleWheelEvent = (event) => {
      const siteHtml = document.getElementsByTagName("html")[0];
      if (siteHtml.classList.contains("slideup-lock-scroll")) {
        return;
      }

      if (event.deltaY !== 0) {
        event.preventDefault();
        lookbookSection.scrollLeft += event.deltaY;
      }
    };

    if (lookbookSection && this.mq.mdPlus) {
      window.addEventListener("wheel", handleWheelEvent, { passive: false });
    }
  },
};
</script>

<style lang="scss" scoped>
.lookbook {
  position: relative;

  @include respond-above(md) {
    height: 100vh;
  }

  :deep(.section) {
    @include respond-above(md) {
      height: 100%;
      display: flex;
      overflow-x: auto;
      box-sizing: border-box;

      &::-webkit-scrollbar {
        display: none;
      }
    }
  }

  :deep(.block) {
    @include respond-above(md) {
      flex: 0 0 auto;
    }

    @include respond-above(md) {
      height: 100%;
    }

    & > *:not(.spacer) {
      height: 600px;

      @include respond-above(md) {
        height: 100%;
      }
    }
  }
}

.close-btn.icon-button {
  display: none !important;
  position: fixed;
  top: 20px;
  right: 20px;
  z-index: 4;

  background: $color-white;
  border: none;
  box-shadow: 2px 4px 10px 0px rgba($color-black, 0.04);
  border-radius: 50%;
  padding: 14px;

  @include respond-above(md) {
    display: block !important;
  }
}
</style>

<style lang="scss">
.template-page-lookbook {
  &.fixed-header {
    @include respond-above(md) {
      padding-top: 0;
    }
  }

  .header-wrapper {
    @include respond-above(md) {
      display: none;
    }
  }

  #shopify-section-footer {
    display: none;
  }
}
</style>
